"use client";
import { useState as d } from "react";
const g = ({
  feHint: e,
  feSeverity: n,
  id: u,
  maxLength: o,
  onChange: r,
  initialCount: a
}) => {
  const [s, c] = d(a ?? 0), l = o ? `${s}/${o}` : void 0, i = e && n === "error" ? `${u}-hint` : void 0;
  return {
    counterValue: l,
    hintId: i,
    onChangeHandler: (t) => {
      c(t.target.value.length), r && r(t, t.target.value);
    }
  };
};
export {
  g as useFormCounter
};
